/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["gaa",[["AM","PM"],u,["LEEBI","SHWANE"]],[["AM","PM"]],[["S","M","T","W","T","F","S"],["Hɔgbaa","Ju","Jufɔ","Shɔ","Soo","Sohaa","Hɔɔ"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["Aharabata","Oflɔ","Otsokrikri","Abɛibe","Agbiɛnaa","Otukwajaŋ","Maawɛ","Manyawale","Gbo","Antɔŋ","Alemle","Afuabe"]],u,[["BCE","CE"]],1,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"GHS",u,u,{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
